"use strict";
/**
 * Marketplace credential-id primitives.
 *
 * `GENERIC_CREDENTIAL_IDS` — id segments that static-analysis emits for
 * step-types without a concrete service slug (e.g. any HTTP endpoint,
 * arbitrary external service). Both the backend install path and the
 * frontend wizard skip the strict `workspaceCredential.service === id`
 * match for these — the template does not know which service it targets,
 * so the user is free to pick any credential.
 *
 * Single source of truth for backend (`template-install.service.ts`) and
 * frontend (`import-setup-wizard.tsx`). When static-analysis derives a
 * real service slug per step-type, entries here should shrink to empty.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERIC_CREDENTIAL_IDS = void 0;
exports.isGenericCredentialId = isGenericCredentialId;
exports.GENERIC_CREDENTIAL_IDS = new Set([
    'httpAuth',
    'externalService',
]);
function isGenericCredentialId(id) {
    return exports.GENERIC_CREDENTIAL_IDS.has(id);
}
